export const TOKEN_KEY = 'token'
export const ENV_KEY = 'env'
export const TOKEN_EXPIRE_TIME = 'token_expire_time'
export const USERNAME_KEY = 'username'

export const getSessionKey = (key) => localStorage.getItem(key)
export const storeSessionKey = (key: string, value: string) => localStorage.setItem(key, value)
export const clearSessionKey = (key: string) => localStorage.removeItem(key)
export const clearLocalStorage = () => {
  localStorage.clear()
}



// WEBPACK FOOTER //
// ./src/util/storage.js